<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">Transport Plan</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout row wrap>
                          <v-flex xs3 child-flex>
                            <v-layout row wrap>
                              <label style="margin-top:20px;margin-right: 10px">Show</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                              ></v-overflow-btn>
                              <label style="margin-top:20px;margin-left: 10px">Entries</label>
                            </v-layout>
                          </v-flex>
                          <v-flex xs3 child-flex></v-flex>
                          <v-flex xs6 child-flex>
                            <v-layout row wrap>
                              <v-text-field
                                label="Search"
                              ></v-text-field>
                              <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap style="margin-top:20px">
                          <label style="margin-left: 20px">Customer Name:</label>
                          <label style="margin-left: 20px">Sales Order No:</label>
                          <label style="margin-left: 20px">Material No:</label>
                          <label style="margin-left: 20px">Batch No:</label>
                          <label style="margin-left: 20px">Destination:</label>
                          <label style="margin-left: 20px">Loading Date:</label>
                          <label style="margin-left: 20px">Qty:</label>
                        </v-layout>
                        <v-data-table
                          :headers="headers"
                          :items="desserts"
                          class="elevation-1"
                          v-show="show1"
                          style="margin-top:20px;margin-bottom:40px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.deliverynote}}</td>
                            <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.tripno}}</a></td>
                            <td class="text-xs-left">{{ props.item.driver}}</td>
                            <td class="text-xs-left">{{ props.item.mobileno}}</td>
                            <td class="text-xs-left">{{ props.item.plateno}}</td>
                            <td class="text-xs-left">{{ props.item.status}}</td>
                            <td class="text-xs-left"><a style="margin-right: 20px"> View PDF </a> | <a style="margin-left: 20px;margin-right: 20px"> Print </a></td>
                          </template>
                        </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Delivery Note', value: 'deliverynote' },
        { text: 'Trip No', value: 'tripno' },
        { text: 'Driver', value: 'driver' },
        { text: 'Mobile No', value: 'mobileno' },
        { text: 'Plate No', value: 'plateno' },
        { text: 'Status', value: 'status' },
        { text: 'Action Tab', value: 'actiontab' }
      ],
      desserts: [
        {
          no: '1',
          deliverynote: '',
          tripno: '',
          driver: '',
          mobileno: '',
          plateno: '',
          status: ''
        },
        {
          no: '2',
          deliverynote: '',
          tripno: '',
          driver: '',
          mobileno: '',
          plateno: '',
          status: ''
        },
        {
          no: '3',
          deliverynote: '',
          tripno: '',
          driver: '',
          mobileno: '',
          plateno: '',
          status: ''
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false
    }
  },
  mounted () {
    console.log('Transportplan page')
  },
  methods: {
    viewtransport () {
      this.$router.push('/Transportplan')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Transportplan.vue